import '../styles/globals.css';
import type { AppProps } from 'next/app';
import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import { DefaultSeo } from 'next-seo';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <DefaultSeo
        title="Plataforma Pigsis"
        titleTemplate="%s"
        defaultTitle="Plataforma Pigsis"
        description="Plataforma Pigsis"
        // twitter={{
        //   handle: '@livekitted',
        //   site: '@livekitted',
        //   cardType: 'summary_large_image',
        // }}
        openGraph={{
          url: 'https://devplataforma.pigsis.com',
          images: [
            {
              url: 'https://devplataforma.pigsis.com/media/logos/home_icon.png',
              width: 2000,
              height: 1000,
              type: 'image/png',
            },
          ],
          site_name: 'Plataforma Pigsis',
        }}
        additionalMetaTags={[
          {
            property: 'theme-color',
            content: '#070707',
          },
        ]}
        // additionalLinkTags={[
        //   {
        //     rel: 'icon',
        //     href: '/favicon.ico',
        //   },
        //   {
        //     rel: 'apple-touch-icon',
        //     href: '/images/livekit-apple-touch.png',
        //     sizes: '180x180',
        //   },
        //   {
        //     rel: 'mask-icon',
        //     href: '/images/livekit-safari-pinned-tab.svg',
        //     color: '#070707',
        //   },
        // ]}
      />
      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
